import Vue from "vue";

export const Utility = function () {

}

Utility.prototype.vueRouterQueryToJson = function (obj) {
    return JSON.parse(JSON.stringify(obj));
}

Utility.prototype.queryStringToJson = function (data) {
    try {
        let json = {};

        for (const item of data) {
            if (item.value !== "null")
                json[item.param] = item.value;
        }
        return json;
    } catch (error) {
        console.log(error)
        return data;
    }
}

Utility.prototype.quesryStringToKeyValuePair = function (data) {
    try {
        let keyValuePair = [];

        for (const key of Object.keys(data)) {
            keyValuePair.push({
                param: key,
                value: data[key]
            })
        }
        return keyValuePair;
    } catch (error) {
        return data;
    }
}

Utility.prototype.routerQueryStringToUrlParams = function (data) {
    return Object.keys(data)
        .map(key => {
            return (
                encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            )
        })
        .join('&')
}

Utility.prototype.isMe = function (id) {
    const tmp = Vue.prototype.$userInfo;
    // console.log(tmp, id);
    if (tmp != null) {
        if (tmp._id == id) {
            return true;
        }
    }
    return false;
}

Utility.prototype.getApiSortOrder = function (val) {
    let systemSortValue = null;
    if (val == 0) systemSortValue = 1;
    else systemSortValue = -1;

    return systemSortValue;
}

Utility.prototype.getLocalSortOrder = function (val) {
    let systemSortValue = null;
    if (val == -1) systemSortValue = 1;
    else systemSortValue = 0;

    return systemSortValue;
}

Utility.prototype.hasHours = function (moment, duration) {
    moment.duration(duration).get("hours") > 0 ? true : false;
}

Utility.prototype.shortenText = function (value, limit) {
    if (value != null) {
        let pureText = value.replace(/<[^>]*>/g, "");
        if (limit != null && pureText.length > limit) {
            let dots = "...";
            // you can also use substr instead of substring
            pureText = pureText.substring(0, limit) + dots;
        }
        return pureText;
    }
    return "";
}

Utility.prototype.roundNumber = function (value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

const plugin = {
    install: function (Vue, options) {
        const utility = new Utility()
        Vue.prototype.$utility = utility
        Vue.$utility = utility

        Vue.filter("localeNumber", (value) => {
            try {
                return value.toLocaleString();
            } catch (e) {
                return value;
            }
        })

        Vue.filter('courseSectionTypeIcon', (value) => {
            let icon = "";
            switch (value) {
                case "VDO":
                    icon = "fas fa-video"
                    break;
                case "PDF":
                    icon = "far fa-file-pdf"
                    break;
                case "BOOK":
                    icon = "fas fa-book"
                    break;
                case "IMG":
                    icon = "far fa-images"
                    break;
                case "URL":
                    icon = "far fa-link"
                    break;
                case "EXAM":
                    icon = "far fa-file-edit"
                    break;
                case "BLOG":
                    icon = "far fa-newspaper"
                    break;

                default:
                    icon = "far fa-file"
                    break;
            }
            return icon;
        })
    }
}

export default plugin